import React from "react";
import BlueCloud from "../../../assets/images/BlueCloud-left.png";
import LeftPhone from "../../../assets/images/phone-left.png";
import MiddlePhone from "../../../assets/images/phone-middle.png";
import RightPhone from "../../../assets/images/phone-right.png";
import Rocket from "../../../assets/images/rocket-image.png";
import Signals from "../../../assets/images/signals-double.png";
import SignalsTwo from "../../../assets/images/signals-double.png";
import SignalsThree from "../../../assets/images/signals-double.png";
import styles from "./Hero.module.scss";

const Hero = () => {
  return (
    <section className={styles.hero}>
      <div className={styles.content}>
        <div className={styles.headingHero}>
          <span className={styles.underline}>Automate</span> your payment
          collections effortlessly with <span>EMIfy</span>
        </div>
      </div>
      <div className={styles.imagewrapper}>
        <div className={styles.bluecloud}>
          <img src={BlueCloud} alt="Blue Cloud" />
        </div>
        <div className={styles.mobilemain}>
          <div className={styles.phoneleft}>
            <img src={RightPhone} alt="Left Phone" />
          </div>
          <div className={styles.phonemiddle}>
            <div className={styles.signals}>
              <img src={Signals} alt="Signals" />
            </div>
            <div className={styles.signalsTwo}>
              <img src={SignalsTwo} alt="SignalsTwo" />
            </div>
            <img src={MiddlePhone} alt="Middle Phone" />
          </div>
          <div className={styles.phoneright}>
            <div className={styles.signalsThree}>
              <img src={SignalsThree} alt="Signals" />
            </div>
            <img src={LeftPhone} alt="Right Phone" />
          </div>
        </div>
        <div className={styles.rocket}>
          <img src={Rocket} alt="Rocket" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
